@if (type() === 'image') {
<img [dfImage]="swatch()"
     [ratio]="'ratio-3-1'"
     [alt]="alt()"
     fill />
} @else {
<ng-content />
}